var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 121,
    viewBox: "0 0 65 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6596 87.8674C64.6596 105.528 49.9329 120.14 32.2723 120.14C14.6117 120.14 0 105.528 0 87.8674C0 83.2077 1.51487 78.8549 2.70375 74.8664C3.89262 70.8779 7.24835 56.2087 26.5197 0.139648H33.2694C25.9061 21.6162 16.3375 50.9354 13.0202 61.5011C15.3596 59.2959 23.5666 55.6142 32.2915 55.6142C49.9521 55.6142 64.6788 70.2259 64.6788 87.8865L64.6596 87.8674ZM58.1592 87.8674C58.1592 73.3899 46.7498 62.0955 32.2723 62.0955C17.7949 62.0955 6.50051 73.3899 6.50051 87.8674C6.50051 102.345 17.9099 113.639 32.2723 113.639C46.6347 113.639 58.1592 102.23 58.1592 87.8674Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber6);
export default __webpack_public_path__ + "static/media/NUMBER_6.04db863cf1238269a41400c4bb5a3db8.svg";
export { ForwardRef as ReactComponent };